//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import locationCity from "@/assets/images/location_city.svg";
import supervisor from "@/assets/images/supervisor.svg";
import userPlatform from "@/assets/images/userPlatform.svg";
import systemInternalUser from "@/assets/images/systemInternalUser.svg";
import systemExternalUser from "@/assets/images/systemExternalUser.svg";
import plugin from "@/assets/images/PluginAdmin/plugin.svg";

export default {
    name: "AQAvatar",
    props: {
        disabled: { type: Boolean, default: false },
        hasUserNotification: { type: Boolean, default: false },
        isEditable: { type: Boolean, default: false },
        type: { type: String, default: "userPlatform" },
        size: { type: Number, default: 36 },
        customAvatar: { type: String, default: null },
        rounded: { type: Boolean, default: true }
    },
    data() {
        return {
            borderSize: 0,
            applicationImage: "/identity/companyInfo/logo/application"

        };
    },
    computed: {
        avatarProps() {
            const avatarTypes = {
                systemInternalUser: {
                    avatarClass: "system-internal-user",
                    src: systemInternalUser,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                systemExternalUser: {
                    avatarClass: "system-external-user",
                    src: systemExternalUser,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                userPlatform: {
                    avatarClass: "user-platform",
                    src: this.customAvatar || userPlatform,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                externalUser: {
                    avatarClass: "external-user",
                    src: this.customAvatar || userPlatform,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                platformManager: {
                    avatarClass: "platform-manager",
                    src: this.customAvatar || userPlatform,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                platformSetManager: {
                    avatarClass: "platform-set-manager",
                    src: this.customAvatar || userPlatform,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                externallySetManager: {
                    avatarClass: "externally-set-manager",
                    src: this.customAvatar || userPlatform,
                    editable: this.isEditable,
                    border: this.size / 18
                },
                app: {
                    avatarClass: "app",
                    src: this.customAvatar || this.applicationImage,
                    editable: this.isEditable,
                    border: "none"
                },
                appUnpublished: {
                    avatarClass: "app-unpublished",
                    src: this.customAvatar || this.applicationImage,
                    editable: this.isEditable,
                    border: "none"
                },
                appPublished: {
                    avatarClass: "app-published",
                    src: this.customAvatar || this.applicationImage,
                    editable: this.isEditable,
                    border: "none"
                },
                publishedNewChanges: {
                    avatarClass: "app-published-new-changes",
                    src: this.customAvatar || this.applicationImage,
                    editable: this.isEditable,
                    border: "none"
                },
                system: {
                    avatarClass: "system",
                    src: supervisor,
                    editable: false,
                    border: this.size / 12
                },
                platform: {
                    avatarClass: "platform",
                    src: supervisor,
                    editable: false,
                    border: this.size / 12
                },
                applicationSpecific: {
                    avatarClass: "application-specific",
                    src: supervisor,
                    editable: false,
                    border: this.size / 12
                },
                externalGroup: {
                    avatarClass: "external-group",
                    src: locationCity,
                    editable: false,
                    border: this.size / 12
                },
                plugin: {
                    avatarClass: "",
                    src: plugin,
                    editable: false,
                    border: "none"
                }
            };
            return avatarTypes[this.type];
        }
    },
    methods: {
        triggerFileOpen() {
            this.$refs.hiddenInput.click();
        },
        onFileSelected(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = ev => {
                this.$emit("customAvatarUploaded", ev.target.result);
            };
        }

    }
};
